module.exports = __webpack_public_path__ + "media/images/covid/icons/spinner-23e2a89d06c2e904c63620fe7778f251.gif";